import WorkflowTagPicker from "../WorkflowTagPicker";
import { TagPickerProps } from "./types";

/**
 * Adapter component to make WorkflowTagPicker compatible with ManageTagsFormDialog
 */
export function WorkflowTagPickerAdapter({
  onAddTag,
  inputRef,
  commonTags,
  recentTags,
  selectedTags,
  tenantId, // Unused for workflow tags since they're system-level
}: TagPickerProps) {
  return (
    <WorkflowTagPicker
      onAddTag={onAddTag}
      inputRef={inputRef}
      commonTags={commonTags}
      recentTags={recentTags}
      selectedTags={selectedTags}
    />
  );
}
